import type {
  HomepageHero,
  HomepageHeroById,
  HomepageHeroState,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageHero';

export const getAll = (state: HomepageHeroState): HomepageHeroById => state.byId;
export const get = (state: HomepageHeroState, id: string): HomepageHero => state.byId[id];
